var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketingMailSvgrepoCom4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_183_2019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.76343 0L17.6043 12.0294L33.4482 0H1.76343Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.06274V22.4734L11.295 10.6407L0 2.06274Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9133 10.6407L35.2083 22.4737V2.06494L23.9133 10.6407Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.743 12.2883L17.6042 15.4307L13.4654 12.2883L1.92822 24.375H33.2798L21.743 12.2883Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3958 29.6429V18.1189H44.6875V20.4887C36.7443 28.23 28.9044 29.5908 24.375 29.5934V46.7661C28.8865 46.6498 36.7388 47.8317 44.6875 55.5888V57.9587H47.3958V46.4345C51.4583 45.7982 54.5593 42.2775 54.5593 38.0389C54.5594 33.8001 51.4583 30.2794 47.3958 29.6429ZM47.3958 43.6855V32.3786C49.9551 33.0013 51.851 35.3035 51.851 38.0389C51.851 40.7742 49.9552 43.0763 47.3958 43.6855Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6397 56.6043C19.0532 52.366 18.6335 49.5492 18.7824 47.3958H21.6668V28.4375H9.47916C4.2521 28.4375 0 32.6897 0 37.9167C0 42.6563 3.49374 46.5834 8.04374 47.2742L12.2282 61.2219C12.6344 62.5899 13.5552 63.6999 14.8146 64.3635C15.5864 64.7834 16.4396 65 17.3063 65C17.8209 65 18.3491 64.9186 18.8636 64.7699C20.4209 64.2825 21.599 63.1992 22.1813 61.6959C22.7907 60.071 22.601 58.1617 21.6397 56.6043Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0001 36.5586H58.2292V39.2669H65.0001V36.5586Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2855 25.4611L54.4978 30.2488L56.4128 32.1638L61.2005 27.3761L59.2855 25.4611Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.407 43.6619L54.4919 45.5769L59.2796 50.3646L61.1947 48.4495L56.407 43.6619Z",
    fill: "#0D0D0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_183_2019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingMailSvgrepoCom4);
export default __webpack_public_path__ + "static/media/marketing-mail-svgrepo-com 4.e25e163d968bb3a8d3f2165eef83a1a8.svg";
export { ForwardRef as ReactComponent };